<template>
  <div class="main-menu fixed top0 left0 w100 z9999 no-print">
    <header class="flex">
      <figure class="pointer mright30px">
        <img @click="routeTo('/comenzi')" src="../assets/logo.svg" alt="logo">
      </figure>

      <button type="button"
              class="hamburger-btn"
              :class="{ 'is-open': isMobileMenuOpen }"
              @click="toggleMobileMenu"
              :aria-expanded="isMobileMenuOpen"
              aria-label="Meniu">
        <span class="hamburger-bar"></span>
        <span class="hamburger-bar"></span>
        <span class="hamburger-bar"></span>
      </button>

    </header>

    <!-- Desktop left sidebar (>=1024px), always expanded. -->
    <aside class="side-nav" aria-label="Navigare principală">
      <div class="side-nav__head">
        <figure class="side-nav__logo pointer" @click="routeTo('/comenzi')">
          <img src="../assets/logo.svg" alt="logo">
        </figure>
      </div>

      <button type="button"
              class="side-nav__cta"
              @click="routeTo('/intrare-noua')"
              cy="comanda-noua">
        <span class="side-nav__cta-plus" aria-hidden="true">+</span>
        <span class="side-nav__text">{{ lang.mainMenu.intrareNoua }}</span>
      </button>

      <nav class="side-nav__nav">
        <ul>
          <li v-for="(item, key) in visibleMenu" :key="key">
            <router-link class="side-nav__item"
                         :cy="item.route"
                         :to="'/' + item.route">
              <span class="side-nav__text">{{ lang.mainMenu[item.name] }}</span>
            </router-link>
          </li>
        </ul>
      </nav>

      <div class="side-nav__foot">
        <button type="button"
                class="side-nav__item"
                @click="routeTo('/setari')"
                cy="setari">
          <span class="side-nav__text">{{ lang.mainMenu.setari }}</span>
        </button>
        <button type="button"
                class="side-nav__item side-nav__item--danger"
                @click="handleLogout()"
                cy="logout">
          <span class="side-nav__text">{{ lang.mainMenu.logout }}</span>
        </button>
        <span class="side-nav__version">v {{ appVersion }}</span>
      </div>
    </aside>

    <transition name="msheet">
      <div v-if="isMobileMenuOpen"
           class="msheet-overlay"
           cy="mobile-menu-sheet"
           role="dialog"
           aria-modal="true"
           aria-label="Meniu principal">
        <div class="msheet-backdrop" @click="toggleMobileMenu"></div>
        <nav class="msheet-panel">
          <div class="msheet-scroll">
            <section v-for="group in mobileGroups"
                     :key="group.id"
                     class="msheet-group">
              <h3 v-if="group.title" class="msheet-group-title">{{ group.title }}</h3>
              <ul class="msheet-list">
                <li v-for="(item, i) in group.items"
                    :key="item.route || item.action"
                    :class="{ 'has-divider': i < group.items.length - 1 }">
                  <button type="button"
                          class="msheet-row"
                          :class="[item.tone]"
                          :cy="`mobile-${item.route || item.action}`"
                          @click="handleItem(item)">
                    <span class="msheet-icon"
                          v-html="icons[item.icon]"
                          aria-hidden="true"></span>
                    <span class="msheet-label">{{ item.label }}</span>
                    <span v-if="item.tone !== 'destructive'"
                          class="msheet-chevron"
                          aria-hidden="true">
                      <svg width="8" height="13" viewBox="0 0 8 13" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M1 1l6 5.5L1 12" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/>
                      </svg>
                    </span>
                  </button>
                </li>
              </ul>
            </section>
          </div>
        </nav>
      </div>
    </transition>
  </div>
</template>

<script>
  import {mapGetters} from "vuex";
  import { version } from "../../package.json";

  const ICONS = {
    inbox: '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M4 4h16v10h-5l-1.5 2.5h-3L9 14H4V4z" stroke="currentColor" stroke-width="1.7" stroke-linejoin="round"/><path d="M4 14v5a1 1 0 001 1h14a1 1 0 001-1v-5" stroke="currentColor" stroke-width="1.7"/></svg>',
    receipt: '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M5 3h14v18l-3-2-3 2-3-2-3 2-2-2V3z" stroke="currentColor" stroke-width="1.7" stroke-linejoin="round"/><path d="M8 8h8M8 12h8M8 16h5" stroke="currentColor" stroke-width="1.7" stroke-linecap="round"/></svg>',
    people: '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="12" cy="8" r="3.5" stroke="currentColor" stroke-width="1.7"/><path d="M5 20c0-3.5 3.1-6 7-6s7 2.5 7 6" stroke="currentColor" stroke-width="1.7" stroke-linecap="round"/></svg>',
    invoice: '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M6 3h8l4 4v14H6V3z" stroke="currentColor" stroke-width="1.7" stroke-linejoin="round"/><path d="M14 3v4h4" stroke="currentColor" stroke-width="1.7" stroke-linejoin="round"/><path d="M9 12h6M9 15h6M9 18h4" stroke="currentColor" stroke-width="1.7" stroke-linecap="round"/></svg>',
    car: '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M3.5 14l1.7-5a2 2 0 011.9-1.4h9.8a2 2 0 011.9 1.4l1.7 5v4.5H3.5V14z" stroke="currentColor" stroke-width="1.7" stroke-linejoin="round"/><circle cx="7.5" cy="17" r="1.5" fill="currentColor"/><circle cx="16.5" cy="17" r="1.5" fill="currentColor"/></svg>',
    calendar: '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><rect x="3.5" y="5" width="17" height="15" rx="2" stroke="currentColor" stroke-width="1.7"/><path d="M3.5 10h17M8 3v4M16 3v4" stroke="currentColor" stroke-width="1.7" stroke-linecap="round"/></svg>',
    link: '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M10 14a4 4 0 015.7 0l3-3a4 4 0 00-5.7-5.7L11 7" stroke="currentColor" stroke-width="1.7" stroke-linecap="round"/><path d="M14 10a4 4 0 01-5.7 0l-3 3a4 4 0 005.7 5.7L13 17" stroke="currentColor" stroke-width="1.7" stroke-linecap="round"/></svg>',
    plusinbox: '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="12" cy="12" r="8.5" stroke="currentColor" stroke-width="1.7"/><path d="M12 8v8M8 12h8" stroke="currentColor" stroke-width="1.7" stroke-linecap="round"/></svg>',
    pluscalendar: '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><rect x="3.5" y="5" width="17" height="15" rx="2" stroke="currentColor" stroke-width="1.7"/><path d="M3.5 10h17M8 3v4M16 3v4M12 13v4M10 15h4" stroke="currentColor" stroke-width="1.7" stroke-linecap="round"/></svg>',
    gear: '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M12 3l1.4 2.3 2.6-.6.5 2.6 2.5 1L18 10.5l1.4 2.2-2 1.8.4 2.6-2.6.4-1.1 2.4L12 18.8l-2.1 1.1-1.1-2.4-2.6-.4.4-2.6-2-1.8L6 10.5 5 8.3l2.5-1 .5-2.6 2.6.6L12 3z" stroke="currentColor" stroke-width="1.6" stroke-linejoin="round"/><circle cx="12" cy="12" r="2.7" stroke="currentColor" stroke-width="1.6"/></svg>',
    exit: '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M14 4h4a2 2 0 012 2v12a2 2 0 01-2 2h-4" stroke="currentColor" stroke-width="1.7" stroke-linecap="round"/><path d="M10 8l-4 4 4 4M6 12h10" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"/></svg>',
  }

  export default {
    name: 'main-menu',
    data () {
      return {
        isMobileMenuOpen: false,
        icons: ICONS,
        appVersion: version,
        menu: [
          { name: 'intrari',    route: 'comenzi'    },
          { name: 'programari', route: 'programari' },
          { name: 'devize',     route: 'devize'     },
          { name: 'links',      route: 'links'      },
          { name: 'clienti',    route: 'clienti'    },
          { name: 'facturi',    route: 'facturi'    },
        ],
      }
    },
    computed: {
      ...mapGetters(['lang', 'isInvoicingConnected']),
      mainMenuLang () {
        return (this.lang && this.lang.mainMenu) || {}
      },
      // Facturi only makes sense once an invoicing provider (SmartBill or Oblio)
      // is connected, so it's hidden from both the desktop sidebar and the
      // mobile sheet until then.
      visibleMenu () {
        return this.menu.filter(item => item.route !== 'facturi' || this.isInvoicingConnected)
      },
      mobileGroups () {
        const t = this.mainMenuLang
        return [
          {
            id: 'navigation',
            title: null,
            items: [
              { route: 'comenzi',    label: t.intrari    || 'Intrări',    icon: 'inbox',    tone: 'primary' },
              { route: 'devize',     label: t.devize     || 'Devize',     icon: 'receipt',  tone: 'primary' },
              { route: 'clienti',    label: t.clienti    || 'Clienți',    icon: 'people',   tone: 'primary' },
              ...(this.isInvoicingConnected
                ? [{ route: 'facturi', label: t.facturi || 'Facturi', icon: 'invoice', tone: 'primary' }]
                : []),
              { route: 'programari', label: t.programari || 'Programări', icon: 'calendar', tone: 'primary' },
              { route: 'links',      label: t.links      || 'Links',      icon: 'link',     tone: 'primary' },
            ],
          },
          {
            id: 'actions',
            title: 'Acțiuni rapide',
            items: [
              { route: 'intrare-noua',    label: t.intrareNoua || 'Intrare nouă',  icon: 'plusinbox',    tone: 'accent' },
              { route: 'programare-noua', label: 'Programare nouă',                 icon: 'pluscalendar', tone: 'accent' },
            ],
          },
          {
            id: 'account',
            title: 'Cont',
            items: [
              { route: 'setari', label: 'Setări', icon: 'gear', tone: 'neutral' },
              { action: 'logout', label: 'Delogare', icon: 'exit', tone: 'destructive' },
            ],
          },
        ]
      },
    },
    watch: {
      isMobileMenuOpen (open) {
        if (typeof document === 'undefined') return
        document.body.style.overflow = open ? 'hidden' : ''
      },
    },
    beforeDestroy () {
      if (typeof document !== 'undefined') {
        document.body.style.overflow = ''
      }
    },
    methods: {
      toggleMobileMenu () {
        this.isMobileMenuOpen = !this.isMobileMenuOpen;
      },
      async handleItem (item) {
        if (item.action === 'logout') {
          this.isMobileMenuOpen = false
          await this.$nextTick()
          return this.handleLogout()
        }
        return this.handleCloseMobileMenu(item.route)
      },
      async handleCloseMobileMenu (route) {
        try {
          if (route === 'intrare-noua' || route === 'programare-noua') {
            this.$store.commit('RESET_FORMULAR_INTRARE_NOUA');
          }
          // On desktop, "Programare nouă" opens the calendar's in-page quick-create
          // panel instead of the standalone form — same as the /programari header
          // button. Mobile keeps navigating to the real page: the panel's styling
          // is desktop-only, and mobile already has its own dedicated form.
          if (route === 'programare-noua' && window.matchMedia('(min-width: 1024px)').matches) {
            await this.$router.push({ path: '/programari', query: { quickCreate: '1' } });
          } else if (this.$route.name !== route) {
            await this.$router.push({ name: route });
          }
          this.isMobileMenuOpen = false;
        } catch (error) {
          if (error.name !== 'NavigationDuplicated') {
            console.error('Navigation error:', error);
          }
          this.isMobileMenuOpen = false;
        }
      },
      routeTo (name) {
        try {
          const routeName = name.replace('/', '');

          if (routeName === 'intrare-noua' || routeName === 'programare-noua') {
            this.$store.commit('RESET_FORMULAR_INTRARE_NOUA');
          }

          if (this.$route.name !== routeName) {
            this.$router.push({ name: routeName }).catch(err => {
              if (err.name !== 'NavigationDuplicated') {
                console.error('Navigation error:', err);
              }
            });
          }
        } catch (error) {
          console.error('Route error:', error);
        }
      },
      handleLogout () {
        this.$store.dispatch('logout')
      }
    }
  }
</script>

<style lang="less">
  @import "../styles/var";

  @apple-font: -apple-system, BlinkMacSystemFont, "SF Pro Text", "Helvetica Neue", sans-serif;
  @apple-blue: #007aff;
  @apple-green: #34c759;
  @apple-gray: #8e8e93;
  @apple-red: #ff3b30;
  @apple-label: #1c1c1e;
  @apple-label-secondary: rgba(60, 60, 67, 0.6);
  @apple-separator: rgba(60, 60, 67, 0.12);
  @apple-grouped-bg: #f2f2f7;
  @apple-row-bg: #ffffff;

  .main-menu {
    --height: 60px;
    @media only screen and (min-width: 0) {
      header {
        height: var(--height);
        padding: 0 16px;
        background-color: @dark-gray;
        align-items: center;
        justify-content: space-between;
      }
    }

    .hamburger-btn {
      position: relative;
      width: 44px;
      height: 44px;
      padding: 0;
      border: 0;
      background: transparent;
      cursor: pointer;
      -webkit-tap-highlight-color: transparent;

      .hamburger-bar {
        position: absolute;
        left: 8px;
        right: 8px;
        height: 2.5px;
        background-color: #fff;
        border-radius: 2px;
        transform-origin: center;
        transition: transform 0.3s cubic-bezier(0.4, 0, 0.2, 1),
                    top 0.3s cubic-bezier(0.4, 0, 0.2, 1),
                    opacity 0.2s ease;

        &:nth-child(1) { top: 13px; }
        &:nth-child(2) { top: 21px; }
        &:nth-child(3) { top: 29px; }
      }

      &.is-open {
        .hamburger-bar:nth-child(1) {
          top: 21px;
          transform: rotate(45deg);
        }
        .hamburger-bar:nth-child(2) {
          opacity: 0;
          transform: scaleX(0);
        }
        .hamburger-bar:nth-child(3) {
          top: 21px;
          transform: rotate(-45deg);
        }
      }

      &:focus-visible {
        outline: none;
        box-shadow: 0 0 0 2px rgba(255, 255, 255, 0.4);
        border-radius: 4px;
      }
    }

    .msheet-overlay {
      position: fixed;
      top: var(--height);
      left: 0;
      right: 0;
      bottom: 0;
      z-index: 9998;
      display: flex;
      flex-direction: column;
      overflow: hidden;
    }

    .msheet-backdrop {
      position: absolute;
      inset: 0;
      background-color: rgba(0, 0, 0, 0.22);
      -webkit-backdrop-filter: blur(4px);
      backdrop-filter: blur(4px);
    }

    .msheet-panel {
      position: relative;
      flex: 1 1 auto;
      display: flex;
      flex-direction: column;
      min-height: 0;
      background-color: @apple-grouped-bg;
      box-shadow: 0 -2px 24px rgba(0, 0, 0, 0.08);
    }

    .msheet-scroll {
      flex: 1 1 auto;
      overflow-y: auto;
      -webkit-overflow-scrolling: touch;
      padding: 22px 16px calc(28px + env(safe-area-inset-bottom));
      font-family: @apple-font;
    }

    .msheet-group {
      margin-bottom: 26px;

      &:last-child {
        margin-bottom: 0;
      }
    }

    .msheet-group-title {
      margin: 0 12px 8px;
      font-family: @apple-font;
      font-size: 13px;
      font-weight: 400;
      line-height: 1.2;
      letter-spacing: -0.08px;
      color: @apple-label-secondary;
      text-transform: uppercase;
    }

    .msheet-list {
      list-style: none;
      margin: 0;
      padding: 0;
      background-color: @apple-row-bg;
      border-radius: 13px;
      overflow: hidden;
      box-shadow: 0 1px 2px rgba(0, 0, 0, 0.03);

      li {
        position: relative;

        &.has-divider .msheet-row::after {
          content: '';
          position: absolute;
          left: 62px;
          right: 0;
          bottom: 0;
          height: 0.5px;
          background-color: @apple-separator;
        }
      }
    }

    .msheet-row {
      position: relative;
      display: flex;
      align-items: center;
      gap: 12px;
      width: 100%;
      min-height: 52px;
      padding: 8px 14px 8px 14px;
      border: 0;
      background: transparent;
      font-family: @apple-font;
      font-size: 17px;
      font-weight: 400;
      letter-spacing: -0.4px;
      color: @apple-label;
      text-align: left;
      cursor: pointer;
      -webkit-tap-highlight-color: transparent;
      transition: background-color 0.15s ease;

      &:active {
        background-color: rgba(120, 120, 128, 0.14);
      }

      &:focus-visible {
        outline: none;
        background-color: rgba(120, 120, 128, 0.10);
      }

      &.primary .msheet-icon     { background-color: @apple-blue;  }
      &.accent .msheet-icon      { background-color: @apple-green; }
      &.neutral .msheet-icon     { background-color: @apple-gray;  }
      &.destructive .msheet-icon { background-color: @apple-red;   }

      &.destructive .msheet-label {
        color: @apple-red;
      }
    }

    .msheet-icon {
      flex: 0 0 auto;
      display: inline-flex;
      align-items: center;
      justify-content: center;
      width: 30px;
      height: 30px;
      border-radius: 7px;
      color: #ffffff;

      svg {
        display: block;
      }
    }

    .msheet-label {
      flex: 1 1 auto;
      min-width: 0;
    }

    .msheet-chevron {
      flex: 0 0 auto;
      display: inline-flex;
      align-items: center;
      color: rgba(60, 60, 67, 0.3);
    }

    .msheet-enter-active,
    .msheet-leave-active {
      transition: opacity 0.22s ease;

      .msheet-panel {
        transition: transform 0.28s cubic-bezier(0.32, 0.72, 0, 1);
      }
    }

    .msheet-enter,
    .msheet-leave-to {
      opacity: 0;

      .msheet-panel {
        transform: translateY(24px);
      }
    }

    /* The sidebar only exists on desktop; hidden by default (mobile uses the
       top bar + sheet above). */
    .side-nav {
      display: none;
    }

    @media only screen and (min-width: 1024px) {
      /* The fixed .main-menu root collapses to 0 height so it never covers
         page content — the <aside> positions itself full-height. */
      height: 0;

      header,
      .hamburger-btn,
      .msheet-overlay {
        display: none;
      }

      .side-nav {
        position: fixed;
        top: 0;
        left: 0;
        bottom: 0;
        z-index: 9999;
        display: flex;
        flex-direction: column;
        width: var(--sidebar-width);
        padding: 16px 0 18px;
        background-color: #272727;
        border-right: 1px solid rgba(255, 255, 255, 0.06);
        overflow: hidden;
      }

      .side-nav__head {
        display: flex;
        align-items: center;
        justify-content: flex-start;
        height: 40px;
        margin-bottom: 10px;
        // Padding-ul stâng aliniază logo-ul cu textul item-urilor (.side-nav__item).
        padding: 0 24px;
      }

      .side-nav__logo {
        display: flex;
        align-items: center;
        overflow: hidden;
        img {
          display: block;
          height: 30px;
          width: auto;
        }
      }

      .side-nav__cta {
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 8px;
        height: 32px;
        margin: 5px 18px 20px;
        padding: 0 14px;
        border: 0;
        border-radius: 4px;
        background-color: #009821;
        color: #fff;
        font-size: var(--fz-menu-cta);
        font-weight: bold;
        letter-spacing: 0.2px;
        white-space: nowrap;
        box-shadow: 0 2px 10px rgba(0, 152, 33, 0.25);
        transition: opacity 0.15s ease;
        .side-nav__cta-plus {
          flex: 0 0 auto;
          font-size: 1.9rem;
          line-height: 1;
          font-weight: bold;
        }
        // keep plus + label as a tight centered group (don't let the label grow)
        .side-nav__text {
          flex: 0 0 auto;
        }
        &:hover {
          opacity: 0.9;
        }
      }

      .side-nav__nav {
        flex: 1 1 auto;
        min-height: 0;
        overflow-x: hidden;
        overflow-y: auto;
        ul {
          display: flex;
          flex-direction: column;
          gap: 0;
        }
      }

      .side-nav__item {
        position: relative;
        display: flex;
        align-items: center;
        gap: 12px;
        width: 100%;
        height: 40px;
        padding: 0 24px;
        border: 0;
        border-radius: 0;
        background: transparent;
        color: #fff;
        font-size: var(--fz-menu-item);
        font-weight: 500;
        letter-spacing: 0.2px;
        text-align: left;
        text-decoration: none;
        white-space: nowrap;
        transition: background-color 0.15s ease;
        .side-nav__text {
          opacity: 0.8;
          transition: opacity 0.15s ease, color 0.15s ease;
        }
        &:hover {
          background-color: #3A3F45;
          .side-nav__text {
            opacity: 0.95;
          }
        }
        &.router-link-active {
          background-color: #3A3F45;
          font-weight: bold;
          .side-nav__text {
            opacity: 1;
          }
        }
        &--danger:hover {
          background-color: rgba(227, 115, 115, 0.14);
          .side-nav__text {
            color: @red;
            opacity: 1;
          }
        }
      }

      .side-nav__text {
        flex: 1 1 auto;
        min-width: 0;
        overflow: hidden;
        text-overflow: ellipsis;
      }

      .side-nav__foot {
        position: relative;
        flex: 0 0 auto;
        display: flex;
        flex-direction: column;
        gap: 0;
        margin-top: 10px;
        padding-top: 12px;
        &::before {
          content: '';
          position: absolute;
          top: 0;
          left: 24px;
          right: 24px;
          height: 1px;
          background-color: rgba(255, 255, 255, 0.07);
        }
        .side-nav__item {
          font-size: var(--fz-menu-foot);
        }
      }

      .side-nav__version {
        margin: 8px 0 0 24px;
        color: rgba(255, 255, 255, 0.4);
        font-size: var(--fz-menu-ver);
        font-weight: bold;
        letter-spacing: 0.3px;
      }

    }
  }
</style>
